import * as types from '../types/topTypes';
import * as catalogService from '../../services/catalogService';
import { mergedCatalogToBrowseCards } from '../../utils/catalogBrowse';

export const fetchTopCatalog = ({ group, limit = 60, language } = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_TOP_REQUEST });
  try {
    const data = await catalogService.getTopCatalog({ group, limit, language });
    const cards = mergedCatalogToBrowseCards(data.items || []);
    const scoreByKey = new Map(
      (data.items || []).map((x) => [
        `${x.category}-${x.tmdbId}`,
        {
          topScore: x?.score?.topScore ?? null,
          voteAvg: x?.score?.voteAvg ?? null,
          voteCount: Number(x?.score?.voteCount || 0),
          reviewAvg: x?.score?.reviewAvg ?? null,
          reviewCount: Number(x?.score?.reviewCount || 0),
        },
      ]),
    );
    const items = cards.map((c) => ({ ...c, score: scoreByKey.get(`${c.category}-${c.tmdbId}`) || null }));
    dispatch({ type: types.FETCH_TOP_SUCCESS, payload: { items, source: data.source || 'top-catalog' } });
  } catch {
    dispatch({ type: types.FETCH_TOP_FAILURE, payload: 'Failed to load top titles' });
  }
};
